import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { scrollWithOffset } from '../utils/scrollWithOffset';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="copyright">
          <p>© 2024 ELAY PROJECT SDN BHD. ALL RIGHTS RESERVED.</p>
          {/* External link remains anchor */}
          <a href="https://claviitech.com/" target="_blank" rel="noopener noreferrer">
            Powered by ClaviiTech
          </a>
        </div>
        <img className="footer-company-img" src="/images/general/ELAY-logo-white.png" alt="logo" />
        <div className="additional-links">
          <Link to="/termsofuse">TERMS OF USE</Link>
          <div className="footer-certs">
            <HashLink smooth to="/aboutus#quality-cert" scroll={scrollWithOffset}>
              <img
                className="footer-cert-iso"
                src="/images/certificates/Pearl ISO9001.png"
                alt="ISO 9001 certified by Pearl Certification"
                width="310"
                height="438"
                loading="lazy"
                decoding="async"
              />
              <figure className="footer-cert-sm">
                <img
                  src="/images/certificates/Pearl Standards Malaysia.png"
                  alt="Standards Malaysia accredited, ACB 053"
                  width="445"
                  height="238"
                  loading="lazy"
                  decoding="async"
                />
                <figcaption aria-hidden="true">ACB 053</figcaption>
              </figure>
            </HashLink>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 